var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 411 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.529 107.995L410.069 174.288L324.863 204.401C296.021 214.594 284.717 249.385 302.059 274.583L353.293 349.029L296.901 390L241.931 318.269C223.325 293.989 186.744 293.989 168.138 318.269L113.169 390L56.7764 349.029L108.01 274.583C125.352 249.385 114.048 214.594 85.2066 204.401L0 174.288L21.5399 107.995L108.173 133.717C137.498 142.423 167.092 120.921 167.874 90.342L170.182 0H239.887L242.196 90.342C242.977 120.921 272.572 142.423 301.896 133.717L388.529 107.995Z",
    fill: "#FD4848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.5c2dbb353cb5f4608a5ded23f0d37e2a.svg";
export { ForwardRef as ReactComponent };